
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[slug]",
      function () {
        return require("private-next-pages/page/[slug].js");
      }
    ]);
  